import { validateArrayResponse } from "../utils";
import { BaseRepository } from "./BaseRepository";

export class SpecialtiesRepository extends BaseRepository {
  async getFirmSpecialties() {
    const cachedData = this.getCached("firm-specialties");
    if (cachedData) {
      return cachedData;
    }

    const response = await this.get("/firm/specialties");
    const validation = validateArrayResponse(response, "/firm/specialties");

    if (!validation.isValid) {
      throw new Error(validation.error);
    }

    this.setCached("firm-specialties", validation.data);
    return validation.data;
  }
}
